import styled from 'styled-components';
import { COLORS } from '@cuemath/comps';
import { AI_ANALYSIS_SEVERITY_COLORS } from '../../../constants/trial-annotation';

export const PanelContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
`;

export const WorkflowSelect = styled.select`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: white;
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${COLORS.COLA};
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: white;
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #e9ecef;
    border-color: ${COLORS.COLA};
  }
`;

export const IssueCard = styled.div`
  padding: 16px;
  margin-bottom: 16px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    border-color: ${COLORS.COLA};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const IssueHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const TimestampButton = styled.button`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  color: white;
  background: #6c757d;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #5a6268;
  }

  &:disabled {
    background: #adb5bd;
    cursor: not-allowed;
  }
`;

export const LabelBadge = styled.span`
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background-color: ${props => {
    if (props.type === 'speaker') return '#6c757d';
    if (props.severity && AI_ANALYSIS_SEVERITY_COLORS[props.severity]) {
      return AI_ANALYSIS_SEVERITY_COLORS[props.severity];
    }
    return '#28a745'; // Default for Low severity or fallback
  }};
  color: ${props => {
    if (props.type === 'speaker') return 'white';
    if (props.severity === 'High') return 'white';
    if (props.severity === 'Medium') return '#000';
    return 'white';
  }};
`;

export const ThemeBadge = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${COLORS.GRAY_DARK};
  margin-bottom: 12px;
`;

export const IssueContent = styled.div`
  display: ${props => (props.expanded ? 'block' : 'none')};
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
  margin-top: 12px;
`;

export const ContentSection = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ContentLabel = styled.div`
  font-weight: 600;
  font-size: 12px;
  color: ${COLORS.GRAY_DARK};
  margin-bottom: 6px;
`;

export const ContentText = styled.div`
  font-size: 13px;
  line-height: 1.6;
  color: #495057;
`;

export const AlternativeText = styled.div`
  font-size: 13px;
  line-height: 1.6;
  color: #28a745;
  background: #d4edda;
  border-left: 4px solid #28a745;
  padding: 12px;
  border-radius: 4px;
  margin-top: 8px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 24px;
  color: #5a5a5a;
  background: #f0f0f0;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
`;

export const FilterModal = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 16px;
  min-width: 300px;
  max-height: 500px;
  overflow-y: auto;
  z-index: 1000;
`;

export const FilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
`;

export const FilterTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.GRAY_DARK};
`;

export const ClearButton = styled.button`
  padding: 4px 8px;
  font-size: 12px;
  color: ${COLORS.COLA};
  background: transparent;
  border: 1px solid ${COLORS.COLA};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${COLORS.COLA};
    color: white;
  }
`;

export const FilterCategory = styled.div`
  margin-bottom: 16px;
`;

export const FilterCategoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }
`;

export const FilterCheckbox = styled.input`
  margin-right: 8px;
  cursor: pointer;
`;

export const FilterCategoryTitle = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
  flex: 1;
`;

export const FilterCount = styled.span`
  font-size: 12px;
  color: #6c757d;
`;

export const FilterOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  cursor: pointer;
  font-size: 12px;
  color: #495057;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }
`;

export const DomainFilterOption = styled(FilterOption)`
  flex: 1;
  margin: 0;
`;

export const FilterWrapper = styled.div`
  position: relative;
`;

export const DomainContainer = styled.div`
  margin-bottom: 12px;
`;

export const DomainLabel = styled.span`
  font-weight: 600;
`;

export const ThemeContainer = styled.div`
  margin-left: 24px;
  margin-top: 4px;
`;

export const DomainHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 0;
  user-select: none;

  &:hover {
    background: #f8f9fa;
    border-radius: 4px;
  }
`;

export const ToggleIcon = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  transition: transform 0.2s ease;
  transform: ${props => (props.expanded ? 'rotate(90deg)' : 'rotate(0deg)')};

  &::before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 4px 0 4px 6px;
    border-color: transparent transparent transparent ${COLORS.GRAY_DARK};
  }
`;

export const ActiveIssueCard = styled(IssueCard)`
  background: ${props => (props.isActive ? '#e7f3ff' : 'white')};
  border-color: ${props => (props.isActive ? '#007bff' : '#e9ecef')};
`;

export const BadgesContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
`;

export const FilterLabel = styled(ContentLabel)`
  margin-bottom: 8px;
`;

export const FullWidthSelect = styled(WorkflowSelect)`
  width: 100%;
  margin-bottom: 16px;
`;

export const FilterButtonContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
